import { Outlet } from 'react-router-dom'
import { Footer } from '../components/common/Footer/Footer'
import { Header } from '../components/dashboard/subContent/header/Header'
import { HeaderMain } from '../components/dashboard/subContent/responsiveHeader/HeaderMain'

export const PrivateCleanLayOut = () => {
    return (
        <div className="container cont-principal">

            <Header isAdmin = {false} />

            <Outlet />

            <Footer />

            <HeaderMain enableMenu={false} />
        </div>
    )
}